export enum SnackbarType {
  SUCCESS = 'success',
  DANGER = 'danger',
  DARK = 'dark',
  DEFAULT = 'default',
  PRIMARY = 'primary',
  INFO = 'info',
  WARNING = 'warning',
  SECONDARY = 'secondary',
}


export enum USER_ACCOUNT_SETTINGS {
  SETTINGS = 'SETTINGS',
  LOGOUT = 'LOGOUT',
  HELP = 'HELP',
}

export enum SIGNUP_ROLES {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
}

export enum ProfileTypeInterFace {
  USER = 'USER_PROFILE',
  ORGANISATION = 'ORGANISATION_PROFILE',
  SECURITY = 'SECURITY_PROFILE',
}

export enum TransactionFilterType {
  DATE = "DATE",
  STATUS = "STATUS",
  TYPE = "TYPE",
  PAYMENT = "PAYMENT",
  WALLET = "WALLET",
  SEARCH = "SEARCH",
  APPROVAL_STATUS = "APPROVAL_STATUS",
  PAYMENT_STATUS = "PAYMENT_STATUS",
  VALUE_CATEGORY = "VALUE_CATEGORY",
  PRODUCT_SELECTED = "PRODUCT_SELECTED"
}


export enum LINKTYPES {
    DASHBOARD = 'DASHBOARD',
    PAYMENTS_MODULE = 'PAYMENTS_MODULE',
    GUEST_VERIFICATION = "GUEST_VERIFICATION",
    LOGIN = 'LOGIN',
    HOME_REPORT_DASHBOARD_MANAGEMENT = "HOME_REPORT_DASHBOARD_MANAGEMENT",
    ID_CARD_MANAGEMENT = "ID_CARD_MANAGEMENT",
    GENERATED_ID_CARD_MANAGEMENT = "GENERATED_ID_CARD_MANAGEMENT",
    HOMEPAGE = 'HOMEPAGE',
    PROJECT_MANAGEMENT = "PROJECT_MANAGEMENT",
    USER_MANAGEMENT = "USER_MANAGEMENT",
    PAYMENT_MANAGEMENT = "PAYMENT_MANAGEMENT"
  }
  
  export enum UserCategoryEnum {
    PRODUCT_ADMIN = 'PRODUCT_ADMIN',
    DEV = 'DEV',
    GUEST = 'GUEST',
  }
  
  export enum USERACCOUNTSETTINGS {
    SETTINGS = 'SETTINGS',
    LOGOUT = 'LOGOUT',
    HELP = 'HELP',
  }